"use client";

import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
const chartData = [
  { month: "January", asset: 186 },
  { month: "February", asset: 305 },
  { month: "March", asset: 237 },
  { month: "April", asset: 73 },
  { month: "May", asset: 209 },
  { month: "June", asset: 214 },
];

const chartConfig = {
  desktop: {
    label: "Assets",
    color: "hsl(var(--chart-1))",
  },
} satisfies ChartConfig;

export function AreaChartCard() {
  return (
    <Card x-chunk="dashboard-01-chunk-4">
      <CardHeader>
        <CardTitle>Porfolio Trend</CardTitle>
        <CardDescription>Porfolio value movement</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig}>
          <AreaChart
            accessibilityLayer
            data={chartData}
            margin={{
              left: 12,
              right: 12,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="month"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={(value) => value.slice(0, 3)}
            />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent indicator="line" />}
            />
            <Area
              dataKey="asset"
              type="natural"
              fill="var(--color-desktop)"
              fillOpacity={0.4}
              stroke="var(--color-desktop)"
            />
          </AreaChart>
        </ChartContainer>
      </CardContent>
      <CardFooter>
        <div className="flex w-full items-start gap-2 text-sm">
          <div className="grid gap-2">
            <div className="flex items-center gap-2 font-medium leading-none"></div>
          </div>
        </div>
      </CardFooter>
    </Card>
  );
}
